import { useEffect } from "react";

/*
  Locks by hiding overflow on the root element rather than fixing the body in
  place: a fixed body stops being the scroll container, so every `sticky`
  header in the page snaps to its unstuck position and the page looks like it
  jumped. Hidden overflow keeps the scroll offset and the sticky layout exactly
  where they were. The scrollbar's width is padded back so centred content
  does not shift when it disappears.

  Counted, so two open overlays (a sheet over a page that has its own lock)
  do not unlock each other when the first one closes.
*/
let locks = 0;

const lock = () => {
  if (locks++ > 0) return;
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.overflow = "hidden";
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
};

const unlock = () => {
  if (--locks > 0) return;
  document.documentElement.style.overflow = "";
  document.body.style.paddingRight = "";
};

export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;
    lock();
    return unlock;
  }, [isLocked]);
};
